import { MouseEvent } from 'react';
import { TMenuChoice } from '../AnchorOrButtonMenuChoice/AnchorOrButtonMenuChoice';
import useStyles from '../AnchorOrButtonMenuChoice/AnchorOrButtonMenuChoice.styles';

export type TButtonMenuChoice = {
  /** The label for the button element */
  label: string;
  /** The URL that the hyperlink points to. If undefined, a button will be rendered for the menu action.
   * If passed, an anchor element will rendered for the menu action.
   */
  // eslint-disable-next-line react/no-unused-prop-types
  href?: undefined;
  /** Function run when the menu action is clicked. Required for button action menu element. */
  onClick(event: MouseEvent<HTMLButtonElement>, menuChoice: TMenuChoice): void;
};

export type TButtonMenuChoiceProps = TButtonMenuChoice & {
  onClickMenuChoice(): void;
};

const ButtonMenuChoice = (props: TButtonMenuChoiceProps) => {
  const { label, onClick, onClickMenuChoice } = props;
  const classes = useStyles();
  return (
    <button
      key={label}
      className={classes.menuButton}
      onClick={(event) => {
        onClick(event, props);
        onClickMenuChoice();
      }}
      type="button"
    >
      {label}
    </button>
  );
};

export default ButtonMenuChoice;
